import styled from "styled-components";
import {HEADER_Z_INDEX} from "../../../../header-consts";

export const AppHeaderCrossBrandListDefaultBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${HEADER_Z_INDEX};
  background-color: ${props => props.theme.colors.backgroundDark};
  color: ${props => props.theme.colors.text};
`;
